import { State } from 'components/desktop/ShoppingCart/_general/AddToCartModal/State';
import { useHandler } from 'hooks/useHandler';

export default function useState() {
	const [state, rf] = useHandler<State.Type>(State.create());
	return {
		state,
		handlers: {
			initialize: rf.createReducerAsync(State.initialize),
			changeAmount: rf.createReducer(State.changeAmount),
			changeSelectedErpRecipeId: rf.createReducer(State.changeSelectedErpRecipeId),
			changeSelectedShoppingCartId: rf.createReducer(State.changeSelectedShoppingCartId),
		},
	};
}

export type RecipeErpViewHandlers = ReturnType<typeof useState>['handlers'];
